import styled from "@emotion/styled";
import {colors, sizes} from "patient-ping-remedy/packages/theme";

export const SearchBarDiv = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  flex-wrap: wrap;
  gap: ${sizes.small};
  margin-bottom: ${sizes.small};
`;

export const StyledTable = styled('table')<{noBorderRadius?: boolean}>`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: ${colors.white};

  tr th {
    padding: 0.8rem 1.6rem;
  }
    
  tr td {
    padding: 0.8rem 1.6rem;
  }
    
  td button {
    text-align: left;
  }
    
  tr th:first-of-type, tr td:first-of-type {
    border-left: 1px solid ${colors.gray2};
  }

  tr th:last-of-type, tr td:last-of-type {
    border-right: 1px solid ${colors.gray2};
  }

  td {
    border-bottom: 1px solid ${colors.gray2};
  }
    
  tr th {
    background: ${colors.gray1};
    text-align: left;
    border-top: 1px solid ${colors.gray2};
  }

  /* top-left border-radius */
  tr:first-of-type th:first-of-type {
    border-top-left-radius: ${({noBorderRadius}) => noBorderRadius ? '0' : '6px'};
  }

  /* top-right border-radius */ 
  tr:first-of-type th:last-of-type {
    border-top-right-radius: ${({noBorderRadius}) => noBorderRadius ? '0' : '6px'};
  }

  /* bottom-left border-radius */ 
  tr:last-of-type td:first-of-type {
    border-bottom-left-radius: ${({noBorderRadius}) => noBorderRadius ? '0' : '6px'};
  }

  /* bottom-right border-radius */
  tr:last-of-type td:last-of-type {
    border-bottom-right-radius: ${({noBorderRadius}) => noBorderRadius ? '0' : '6px'};
  }
    
  .no-error-space-dropdown > span:last-of-type {
    display: none;
  }
  .no-error-space-dropdown {
    margin-bottom: ${sizes.xxSmall};
  }
`;

export const ThButton = styled('th')`
  padding: ${sizes.xSmall};
  cursor: pointer;
`;

export const QuickFilterWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${sizes.xSmall};
  flex: 1;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${sizes.small};
`;

export const FilterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: ${sizes.small};
`;

export const NoDataWrapper = styled.span`
  display: flex;
  justify-content: center;
  padding: ${sizes.xSmall};
`;
